import PropTypes from 'prop-types';

import './NotFoundPage.css';

import CenteredBlock from '../../components/SimpleComponents/CenteredBlock';
import Layout from '../../layouts/layouts';

/**
 * Not Found page
 * @content
 */
const NotFoundPage = ({ title }) => {
	return (
		<Layout title={title}>
			<CenteredBlock>
				<div className="text">
					<center>Page not found</center>
				</div>
			</CenteredBlock>
		</Layout>
	);
};

NotFoundPage.propTypes = {
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
};

export default NotFoundPage;
